const isSubmitting = (state) => state.downloads.isSubmitting;
const isRequestSuccessful = (state) => state.downloads.isRequestSuccessful;

export default {
  isSubmitting,
  isRequestSuccessful,
};
